import styled from 'styled-components'
import Measurement from './Measurement'
import { Side } from 'modules/shares/types'
import { midPointBetweenPoints } from 'utils/geometry'

interface PillProps {
  side: Side
  measurement: Measurement
}
const Pill = styled.span.attrs((props: PillProps) => {
  return { 'data-testid': `pill-${props.side}` }
})<PillProps>`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.inspect.guide};
  color: white;
  border-radius: ${({ theme }) => theme.radii.rounded};
  font-size: 0.625rem;
  padding: 3px 5px; /* stylelint-disable-line scales/space */
  line-height: 1;
  text-align: center;

  ${({ side, measurement }) => {
    const offset = 2
    const midPoint = midPointBetweenPoints(
      measurement.startPoint,
      measurement.endPoint
    )

    switch (measurement.axis) {
      case 'x':
        return {
          top: `${midPoint.y - offset}px`,
          left: `${midPoint.x}px`,
          transform: 'translate(-50%, -100%)',
        }

      case 'y':
        return {
          top: `${midPoint.y}px`,
          left: `${midPoint.x - offset}px`,
          transform: 'translate(-100%, -50%)',
        }
    }
  }}
`

export default Pill
